import { __assign } from 'tslib';
import React from 'react';

function Body(props) {
    return React.createElement("div", __assign({}, props));
}

export { Body };
//# sourceMappingURL=Body.esm.js.map
